import { jsx as a, Fragment as k, jsxs as t } from "react/jsx-runtime";
import { createPortal as O } from "react-dom";
import { ModalContainer as p, ModalOverlay as x, ModalBox as R, BORDER_RADIUS_VAR as A, ModalBanner as D, ModalBannerCloseButtonIcon as T, ModalContent as _, ModalHeader as w, ModalCloseButtonIcon as c, ModalTitle as L } from "./style.js";
import { getOrCreatePortalElement as j } from "../../services/runtime/index.js";
import { Xmark as s, ChevronLeft as v } from "@pelando/fontawesome/icons";
import { useState as E } from "react";
import { useTranslation as H } from "../../hooks/useTranslation/index.js";
const P = "modal-portal";
function z({
  children: m,
  onClose: n,
  style: u,
  title: d,
  preventClose: l,
  bannerImage: r,
  modalBoxBorderRadius: h,
  modalPageStyle: o
}) {
  const { t: i } = H("common"), [M, b] = E(!1), f = d || !l, B = !l && r, C = !l && !r, e = () => {
    b(!0), setTimeout(() => {
      n == null || n();
    }, 300);
  };
  return /* @__PURE__ */ a(k, { children: O(
    /* @__PURE__ */ t(
      p,
      {
        role: "dialog",
        "aria-describedby": "modal-title",
        "aria-hidden": M,
        children: [
          /* @__PURE__ */ a(
            x,
            {
              "data-testid": "modal-overlay",
              onClick: () => {
                l || e();
              }
            }
          ),
          /* @__PURE__ */ t(
            R,
            {
              style: {
                [A]: h
              },
              "data-modalPage": o,
              children: [
                r && /* @__PURE__ */ t(D, { children: [
                  r,
                  B && /* @__PURE__ */ a(
                    T,
                    {
                      icon: s,
                      "aria-label": i("close-buttton-aria-label"),
                      role: "button",
                      onClick: e
                    }
                  )
                ] }),
                /* @__PURE__ */ t(
                  _,
                  {
                    $extendesStyle: u,
                    "data-modalPage": o,
                    children: [
                      f && /* @__PURE__ */ t(w, { "data-modalPage": o, children: [
                        o && /* @__PURE__ */ a(
                          c,
                          {
                            icon: v,
                            "data-modalPage": o,
                            "aria-label": i("close-buttton-aria-label"),
                            role: "button",
                            onClick: e
                          }
                        ),
                        d && /* @__PURE__ */ a(
                          L,
                          {
                            "data-modalPage": o,
                            id: "modal-title",
                            children: d
                          }
                        ),
                        C && !o && /* @__PURE__ */ a(
                          c,
                          {
                            icon: s,
                            "aria-label": i("close-buttton-aria-label"),
                            role: "button",
                            onClick: e
                          }
                        )
                      ] }),
                      m
                    ]
                  }
                )
              ]
            }
          )
        ]
      }
    ),
    j(P)
  ) });
}
export {
  z as Modal
};
